import React from 'react'

const Contacts = () => {
    return (

        <div name="contact"
            className='w-full h-screen bg-gradient-to-b from-black to-gray-800 p-4 text-white'>

            <div className='flex flex-col p-4 justify-center
        max-w-screen-lg mx-auto h-full'>
                <div className='pb-8'>

                    <p className='text-4xl font-bold inline border-b-4
                border-gray-500'>Contact</p>

                    <p className='py-6'>Whether it's building a new project from scratch or enhancing an existing one, I'm always up for a coding adventure. Let's bring your ideas to life together!</p>

                </div>

                <div className='flex justify-center items-center'>
                    <form action="https://getform.io/f/58ff4ed2-d7ae-4f2a-b995-1dcb3c80d610" className=' flex flex-col w-full md:w-1/2' method='POST'>

                        <input type="text" name='name' placeholder='Enter Your Name'

                            className='p-2 bg-transparent border-2 rounded-md text-white focus:outline-none' />

                        <input type="text" name='email' placeholder='Enter Your Email'

                            className='p-2 my-4 bg-transparent border-2 rounded-md text-white focus:outline-none' />

                        <textarea  placeholder='Enter Your Message' name="message" rows="10" cols="30" className='p-2
        bg-transparent border-2 rounded-md text-white focus:outline-none'></textarea>

                        <button className='text-white bg-gradient-to-b from-cyan-500 to-blue-500 px-6
py-3 my-8  mx-auto flex items-center rounded-md hover:scale-110 duration'>Let's Talk</button>

                    </form>
                </div>

            </div>


        </div>
    )
}

export default Contacts
